import Loading from "@/components/Loading";
import AdminLayout from "@/layout/AdminLayout";
import React from "react";
import {PAGE_URL} from "../services/constant";
const Permission = React.lazy(() =>
    import('../Permission')
);
const permissionRoutesRegistry = [
    {
        path: PAGE_URL.PERMISSION_PAGE,
        element: <Permission />,
        loading: <Loading />,
        layout: AdminLayout,
    },
];

export default permissionRoutesRegistry;
